import { Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

/**
 * The social sign-in buttons of the auth pages, stacked full width as in
 * the design: provider logo on the left, "Sign up with …" / "Sign in with
 * …" centered. The page owns the flow and does the submit.
 */
@Component({
  selector: 'app-oidc-buttons',
  templateUrl: './oidc-buttons.component.html',
  imports: [TranslocoModule],
  host: { class: 'flex flex-col gap-2.5' },
})
export class OidcButtonsComponent {
  /** Provider ids the flow offers (google, microsoft, github, …). */
  readonly providers = input.required<string[]>();

  /** Sign-up or sign-in wording. */
  readonly intent = input<'register' | 'login'>('login');

  readonly busy = input(false);

  readonly picked = output<string>();
}
